import { useNavigation } from 'react-router'
import { useEffect, useState } from 'react'

export function LoadingBar() {
  const navigation = useNavigation()
  const [progress, setProgress] = useState(0)
  const [visible, setVisible] = useState(false)
  const isLoading = navigation.state === 'loading' || navigation.state === 'submitting'

  useEffect(() => {
    if (isLoading) {
      setVisible(true)
      setProgress(20)
      const t1 = setTimeout(() => setProgress(50), 100)
      const t2 = setTimeout(() => setProgress(70), 300)
      const t3 = setTimeout(() => setProgress(85), 600)
      return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3) }
    } else {
      setProgress(100)
      const t = setTimeout(() => { setVisible(false); setProgress(0) }, 300)
      return () => clearTimeout(t)
    }
  }, [isLoading])

  return (
    <>
      {/* Top progress bar */}
      {(visible || progress > 0) && (
        <div className="fixed left-0 right-0 top-0 z-[100] h-1">
          <div
            className="h-full bg-gradient-to-r from-primary to-blue-400 shadow-[0_0_10px_rgba(37,99,235,0.6)] transition-all duration-300 ease-out"
            style={{ width: `${progress}%`, opacity: progress === 100 ? 0 : 1 }}
          />
        </div>
      )}

      {/* Subtle page dimming during load — no blocking overlay */}
      {isLoading && (
        <div className="pointer-events-none fixed inset-0 z-[99] bg-white/30 transition-opacity duration-200" />
      )}
    </>
  )
}
